import { Container, Section } from '../components/atomic';
import CollaborateCallToAction from '../components/collaborate/CollaborateCallToAction';
import CollaboratePageHeader from '../components/collaborate/CollaboratePageHeader';
import CollaborationTypesSection from '../components/collaborate/CollaborationTypesSection';
import EngagementModelsSection from '../components/collaborate/EngagementModelsSection';
import IntroductionSection from '../components/collaborate/IntroductionSection';
import WhyCollaborateSection from '../components/collaborate/WhyCollaborateSection';
import { ContentPageLayout } from '../layouts';

/**
 * Collaborate With Us page component for RSM Collective
 *
 * General collaboration page for healthcare organizations, innovators, and potential partners
 * Refactored into smaller, focused components for better maintainability
 *
 * @returns {JSX.Element} Collaborate With Us page component
 */
function CollaborateWithUs() {
  return (
    <ContentPageLayout backgroundColor="#f8f9fa">
      <Section
        sx={{
          py: 0,
          position: 'relative',
        }}
      >
        <CollaboratePageHeader />

        <Container maxWidth="lg" sx={{ pb: 8 }}>
          <IntroductionSection />
          <CollaborationTypesSection />
          <WhyCollaborateSection />
          <EngagementModelsSection />

          {/* COMMENTED OUT FAKE STATISTICS TEMPLATE
        <Box sx={{ mb: 8, textAlign: 'center' }}>
          <Heading
            variant="h2"
            sx={{ mb: 4, fontSize: '1.75rem', fontWeight: 600 }}
          >
            Our Proven Track Record
          </Heading>
          <Grid container spacing={4} sx={{ justifyContent: 'center' }}>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ textAlign: 'center', maxWidth: '200px', mx: 'auto' }}>
                <Text
                  sx={{
                    fontSize: '2.25rem',
                    fontWeight: 'bold',
                    color: 'primary.main',
                  }}
                >
                  500+
                </Text>
                <Text sx={{ fontSize: '0.9rem', color: '#6c757d' }}>
                  Healthcare Organizations Served
                </Text>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ textAlign: 'center', maxWidth: '200px', mx: 'auto' }}>
                <Text
                  sx={{
                    fontSize: '2.25rem',
                    fontWeight: 'bold',
                    color: 'primary.main',
                  }}
                >
                  $50M+
                </Text>
                <Text sx={{ fontSize: '0.9rem', color: '#6c757d' }}>
                  In Cost Savings Generated
                </Text>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ textAlign: 'center', maxWidth: '200px', mx: 'auto' }}>
                <Text
                  sx={{
                    fontSize: '2.25rem',
                    fontWeight: 'bold',
                    color: 'primary.main',
                  }}
                >
                  95%
                </Text>
                <Text sx={{ fontSize: '0.9rem', color: '#6c757d' }}>
                  Client Satisfaction Rate
                </Text>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ textAlign: 'center', maxWidth: '200px', mx: 'auto' }}>
                <Text
                  sx={{
                    fontSize: '2.25rem',
                    fontWeight: 'bold',
                    color: 'primary.main',
                  }}
                >
                  40%
                </Text>
                <Text sx={{ fontSize: '0.9rem', color: '#6c757d' }}>
                  Average Efficiency Gain
                </Text>
              </Box>
            </Grid>
          </Grid>
        </Box>
        END COMMENTED OUT FAKE STATISTICS TEMPLATE */}

          <CollaborateCallToAction />
        </Container>
      </Section>
    </ContentPageLayout>
  );
}

export default CollaborateWithUs;
